import usePageTitle from "@/hooks/usePageTitle";
import { Navigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import useCapabilities, { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";
import MobileSectionLandingPage from "./MobileSectionLandingPage";

const pattern = "/sections/:sectionId";

export default function SectionIndexPage() {
  usePageTitle(pattern, "Sections | Section Details");
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const { sectionId } = useParams();
  const { loaded: capabilitiesLoaded } = useCapabilities();
  const canViewPeople = useHasCapabilityBool({
    domain: DOMAIN.SECTIONS,
    permission: PERMISSION.viewPeople
  });

  if (isMobile) {
    return <MobileSectionLandingPage />;
  }

  if (!capabilitiesLoaded) {
    return null;
  }

  const homeSegment = canViewPeople ? "people/section-people" : "jobs";
  return <Navigate to={`/sections/${sectionId}/${homeSegment}`} replace />;
}
